import { Formik, Form } from "formik";
import * as Yup from "yup";
import CustomInput from "../../../../common/components/Form/CustomInput";

const validationSchema = Yup.object({
  email: Yup.string().email("Invalid email").required("Required"),
  fullName: Yup.string().required("Required"),
  companyName: Yup.string(),
  phoneNumber: Yup.string().matches(
    /^\+?[0-9]{10,15}$/,
    "Enter a valid phone number"
  ),
  description: Yup.string(),
});

const GetInTouch = () => {
  return (
    <div className="flex flex-col gap-14 p-10 bg-lightGray shadow-blurShadow rounded-xl">
      <h2 className="text-primary text-[28px] font-semibold tracking-[0] leading-[100%]">
        Get in Touch
      </h2>
      <Formik
        initialValues={{
          fullName: "",
          email: "",
          description: "",
          phoneNumber: "",
          companyName: "",
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => console.log(values)}
        validateOnChange={false}
        validateOnBlur={true}
      >
        <Form className="flex flex-col gap-10">
          <div className="flex items-enter w-full flex-col md:flex-row gap-10 md:gap-[30px]">
            <div className="flex flex-col gap-2.5 w-full md:w-1/2">
              <CustomInput
                placeholder="Your full name"
                label="Name"
                name="fullName"
                type="text"
              />
            </div>
            <div className="flex flex-col gap-2.5 w-full md:w-1/2">
              <CustomInput
                label="Email"
                placeholder="your@email.com"
                name="email"
                type="email"
              />
            </div>
          </div>
          <div className="flex items-enter w-full flex-col md:flex-row gap-10 md:gap-[30px]">
            <div className="flex flex-col gap-2.5 w-full md:w-1/2">
              <CustomInput
                isRequired={false}
                label="Company Name"
                placeholder="Your company"
                name="companyName"
                type="text"
              />
            </div>
            <div className="flex flex-col gap-2.5 w-full md:w-1/2">
              <CustomInput
                isRequired={false}
                label="Phone Number"
                placeholder="+234 901 234 5678"
                name="phoneNumber"
                type="number"
              />
            </div>
          </div>
          <CustomInput
            isRequired={false}
            label="Description"
            placeholder="Tell us about your inquiry"
            name="description"
            as="textarea"
            type="text"
            rows={4}
            className="resize-none"
          />
          <button
            type="submit"
            className="bg-primary text-white h-12 mt-2.5 flex flex-row justify-center items-center rounded-md gap-2.5 hover:bg-primary/80 transition duration-300"
          >
            <span>Send Message</span>
            <img src="/assets/images/send-icon.svg" alt="send-icon" />
          </button>
        </Form>
      </Formik>
    </div>
  );
};

export default GetInTouch;
